import { Typography } from "@mui/material";
import { createBrowserRouter } from "react-router-dom";
import { Home } from "./pages/home";
import App from "./App";
import { MainLayout } from "./components/MainLayout";

export const routes = createBrowserRouter([
  {
    element: <App />,
    children: [
      {
        element: <MainLayout />,
        errorElement: <Typography>404</Typography>,
        children: [
          {
            path: "/",
            element: <Home />,
          },
        ],
      },
    ],
  },
]);
